import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "payout-add-tile",
	templateUrl: "./payout-add-tile.component.html",
	styleUrls: ["./payout-add-tile.component.scss"],
	standalone: false
})
export class PayoutAddTileComponent {
	@Output()
	public clicked: EventEmitter<void> = new EventEmitter<void>();

	@Input()
	public locaKey: string = "add new account";

	public onButtonPress(): void {
		this.clicked.emit();
	}
}
